import React, {Component} from 'react';
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import {formatToDollar, runAfterLoadSession} from "../../utils/Utility";
import {history} from "../../history/History";
import {getCategories, getFields, taskCreate, taskPrice, uploadFilePrivate} from "../../utils/API";
import Loading from "../shared/Loading";
import InputMaterial from "../shared/InputMaterial";
import UploadImage from "../shared/UploadImage";
import Calendar from 'react-calendar'
import {error, show} from "../../utils/Toast";
import KeyVal from "../shared/KeyVal";
import {NavLink} from "react-router-dom";

class NewTask extends Component {

    constructor(props) {
        super(props);

        this.state = {
            statusApi: false,
            showOffline: false,
            step: 1,
            fields: [],
            loadingPage: true,
            createTaskApi: false,
            field: undefined,
            category: undefined,
            deadline: undefined,
            inquiry: undefined,
            title: '',
            description: '',
            files: []
        }
    }

    componentDidMount() {
        runAfterLoadSession(() => {
            if (this.props.tutorEnv)
                history.push("/hom")

            getFields((res) => {
                this.setState({
                    fields: res,
                    loadingPage: false
                })
            })
        })

    }

    onBack = () => {
        if (this.state.step === 1) {
            history.push("/hom")
        } else if (this.state.step === 2) {
            this.setState({
                field: undefined,
                step: 1
            })
        } else if (this.state.step === 3) {
            this.setState({
                category: undefined,
                step: 2
            })
        } else if (this.state.step === 4) {
            this.setState({
                step: 3
            })
        }
    }

    onChooseField = (field) => {
        if (this.state['category' + field.hashId]) {
            this.setState({
                field: field,
                step: 2
            })
        } else {
            this.setState({
                loadingPage: true,
                field: field
            })
            getCategories(field.hashId, (res) => {
                this.setState({
                    ['category' + field.hashId]: res,
                    step: 2,
                    loadingPage: false,
                })
            })
        }
    }

    onChooseCategory = (category) => {
        this.setState({
            category: category,
            step: 3,
        })
    }

    setTitle(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 64)
            return
        this.setState({
            title: evt.target.value,
        })
    }

    setDescription(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 500)
            return
        this.setState({
            description: evt.target.value,
        })
    }

    review = () => {
        if (this.state.title.trim().length < 5 ||
            this.state.description.trim().length === 0 ||
            !this.state.deadline) {
            error('All parameter are required')
            return
        }
        if (this.state.deadline.getTime() < new Date().getTime()) {
            error('Deadline cannot be earlier than today')
            return
        }
        this.setState({
            step: 4,
            loadingPage: true
        })
        taskPrice(this.state.category.hashId, this.state.deadline.getTime(), (res) => {
            this.setState({
                inquiry: res,
                loadingPage: false
            })
        })
    }

    getStepDes = () => {
        switch (this.state.step) {
            case 1:
                return "Step 1 - Choose your field";
            case 2:
                return "Step 2 - Choose your category";
            case 3:
                return "Step 3 - Fill the fields";
            case 4:
                return "Step 4 - Review request";
            default:
                return "unknown"
        }
    }

    createTask = () => {
        this.setState({
            createTaskApi: true
        })
        taskCreate(this.state.title, this.state.description, this.state.category.hashId,
            this.state.deadline.getTime(), this.props.match.params.tutorId, (res) => {
                if (this.state.files.length > 0) {
                    show("Please wait, Sending files")
                    this.sendFile(res[0].hashId, 0)
                } else {
                    history.goBack();
                    show("Task created")
                }
            }, () => {
                this.setState({
                    createTaskApi: false
                })
            })
    }

    sendFile = (taskHashId, index) => {
        if (index >= this.state.files.length) {
            if (this.state.category.hashId)
                history.push("/hom")
            else
                history.goBack();
            show("Task created")
            return
        }
        uploadFilePrivate(taskHashId, this.state.files[index], () => {
            this.sendFile(taskHashId, index + 1);
        }, () => {
            error("There was an error sending some files")
            this.sendFile(taskHashId, index + 1);
        })
    }

    render() {
        return (
            <div className="contain-app">
                <button className="back-btn" onClick={this.onBack}>
                    <i className="icon-arrow_back_ios"/>
                </button>
                <div className="title-login pt-3 bold">
                    <h4>Request Task</h4>
                </div>

                <div className="mt-3 mb-5 text-center">
                    <h5>{this.getStepDes()}</h5>
                </div>
                <div className="body-login">
                    <div>
                        <Loading show={this.state.loadingPage}>
                            <div>
                                {this.state.step === 1 && <div>
                                    {
                                        this.state.fields.map((field) =>
                                            <button key={field.hashId} className="choose-cat"
                                                    onClick={() => this.onChooseField(field)}>
                                                <div>
                                                    <img src={window.baseFile + field.logoUrl} alt={field.name}/>
                                                </div>
                                                <div>
                                                    <span>{field.name}</span>
                                                </div>
                                            </button>)
                                    }
                                </div>}
                                {this.state.step === 2 && <div>
                                    {
                                        this.state['category' + this.state.field.hashId].map((category) =>
                                            <button key={category.hashId} className="choose-cat"
                                                    onClick={() => this.onChooseCategory(category)}>
                                                <div>
                                                    <img src={window.baseFile + category.logoUrl} alt={category.name}/>
                                                </div>
                                                <div>
                                                    <span>{category.name}</span>
                                                </div>
                                            </button>)
                                    }
                                </div>}
                                {this.state.step === 3 && <div>
                                    <InputMaterial id="Title"
                                                   type="text"
                                                   valid={this.state.title.length === 0 ? undefined : (this.state.title.length >= 5)}
                                                   value={this.state.title}
                                                   wrongMsg={"Title must be at least 5 character"}
                                                   title="Title"
                                                   onChange={(evt) => this.setTitle(evt)}
                                    />
                                    <InputMaterial id="Description"
                                                   multiLine={true}
                                                   type="text"
                                                   value={this.state.description}
                                                   title="Description"
                                                   onChange={(evt) => this.setDescription(evt)}
                                    />
                                    <UploadImage id="files"
                                                 ignoreType
                                                 onComplete={(file) => {
                                                     this.setState({
                                                         files: this.state.files.concat([file])
                                                     })
                                                 }}
                                    >
                                        <div className="upload-image-photo">
                                            <span>{'Upload files'}</span>
                                        </div>
                                    </UploadImage>
                                    <div>
                                        {
                                            this.state.files.map((file, i) => <div key={i} className="mb-1">
                                                <span>{file.name}</span>
                                                <button onClick={() => {
                                                    let index = this.state.files.indexOf(file);
                                                    let newFiles = []
                                                    for (let j = 0; j < this.state.files.length; j++) {
                                                        if (j !== index)
                                                            newFiles.push(this.state.files[j])
                                                    }
                                                    this.setState({files: newFiles})
                                                }}><i className="icon-trash red-text ml-2 s1-25-x"/></button>
                                            </div>)
                                        }
                                    </div>
                                    <div className="text-center mt-3 mb-2">
                                        <span>Choose Deadline</span>
                                    </div>
                                    <Calendar onChange={(date) => {
                                        let deadline = this.state.deadline
                                        if(deadline){
                                            date.setHours(deadline.getHours())
                                            date.setMinutes(deadline.getMinutes())
                                        }
                                        this.setState({deadline: date})
                                    }}/>
                                    <input className="text-center" type="time" id="deadlineInput"
                                           value={this.state.deadline ? (this.state.deadline.getHours() < 10 ? '0' : '') + this.state.deadline.getHours() + ':' + (this.state.deadline.getMinutes() < 10 ? '0' : '') +this.state.deadline.getMinutes() : '00:00'}
                                           onChange={(evt) => {
                                               let deadline = this.state.deadline
                                               deadline.setHours(parseInt(evt.target.value.split(":")[0]))
                                               deadline.setMinutes(parseInt(evt.target.value.split(":")[1]))
                                               this.setState({
                                                   deadline: deadline
                                               })
                                           }}/>
                                    <div className="pb-3">
                                        <button
                                            className="mt-4 waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                            onClick={this.review}>
                                            <span>Continue</span>
                                        </button>
                                    </div>
                                </div>}
                                {
                                    this.state.step === 4 && this.state.inquiry && <div>
                                        <div className="text-center">
                                            <h4>{this.state.title}</h4>
                                        </div>
                                        <div className="mt-3 mt-3 pb-3 border-bottom-dashed">
                                            <KeyVal name="Field:" value={this.state.field.name}/>
                                            <KeyVal name="Category:" value={this.state.category.name}/>
                                            <KeyVal name="Deadline:"
                                                    value={this.state.deadline.toLocaleDateString("en-US")}/>
                                        </div>

                                        <div className="mt-3 pb-3 border-bottom-dashed">
                                            <KeyVal name="Amount"
                                                    value={formatToDollar(this.state.inquiry.initialAmount)}/>
                                            <KeyVal name="Fee" value={formatToDollar(this.state.inquiry.fee)}/>
                                            <KeyVal name="Tax" value={formatToDollar(this.state.inquiry.tax)}/>
                                        </div>
                                        <div className="mt-3">
                                            <KeyVal green name="Total amount"
                                                    value={formatToDollar(this.state.inquiry.amount)}/>
                                        </div>
                                        <div className="mt-5 mb-1">
                                            <span className="font-size-small">The amount of task will be paid from your card after finding a tutor</span>
                                        </div>
                                        <button
                                            className="waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                            disabled={this.state.createTaskApi || (!this.props.profile.haveCard && this.props.profile.countryName !== 'Bangladesh')}
                                            onClick={this.createTask}>
                                            <Loading show={this.state.createTaskApi}>
                                                <span>Confirm</span>
                                            </Loading>
                                        </button>
                                        {!this.props.profile.haveCard && this.props.profile.countryName !== 'Bangladesh' &&
                                        <div className="mt-3 mb-1 text-center">
                                            <span className="red-text">you can not create request, please add card number to your profile</span>
                                            <NavLink className="d-block mt-2 text-center" to="/hom/profile">
                                                <span className="grey-text">Go to profile</span>
                                            </NavLink>
                                        </div>}
                                    </div>
                                }
                            </div>
                        </Loading>
                    </div>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        tutorEnv: state.param[Objects.tutorEnv],
        profile: state.param[Objects.profile],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewTask)
